(function () {
  'use strict';

  angular
    .module('account.profile')
    .config(config);

  function config($stateProvider, configOptions) {
    $stateProvider
      .state('account.profile', angular.extend({}, configOptions.defaultStateParams, {
        url: '/profile',
        templateUrl: 'account/account.tpl.html',
        controller: 'AccountCtrl',
        controllerAs: 'account',
        onEnter: ['RouterHelper', function (RouterHelper) {
          RouterHelper.activateTab('account', 'profile');
        }]
      }));
  }
}());
